import { ICodeName } from 'model/ICommon';
import * as bankInfoModel from 'model/IBankInfo';

export const enumProcessingStatus = {
    Init: 0,
    Processing: 1,
    Processed: 2
};

export const constModel = "LYRIQ";


//export const enumOrdersTabName = {
//    Orders: 0,
//    Returns: 1,
//    // Refunds: 2,
//    Items: 2,
//    Return_Details: 11,
//    Item_Details: 22,
//    // Refund_Details: 22,
//};

//////---------------------useCountryState hook to get data
//export const constCountryList = [
//    { name: 'Australia', code: 'AU' },
//    { name: 'New Zealand', code: 'NZ' },
//];

export const constStateList: ICodeName[] = [
    { name: 'ACT', code: 'ACT' },
    { name: 'NSW', code: 'NSW' },
    { name: 'NT', code: 'NT' },
    { name: 'QLD', code: 'QLD' },
    { name: 'SA', code: 'SA' },
    { name: 'TAS', code: 'TAS' },
    { name: 'VIC', code: 'VIC' },
    { name: 'WA', code: 'WA' },
];

export const constGst: number = 0.1;



export const enumPaymentStatus = {
    Success: "Success",
    Fail: "Fail",
    Incomplete: "Incomplete",
    Cancel: "Cancel",
    Unknow: "Unknow",
};

//delivery option's value
//RD and Yana are sharing these value. Do not change them unless get Yana confirmed.
export const enumDeliveryOptions = {
    Pickup: "Pick Up",
    HomeDelivery: "Regional Delivery",
}
//delivery option's display name
//These value are used to show label, and can be changed as scope request.
export const enumDeliveryOptionsDisplayName = {
    Pickup: "In-store Collection",
    HomeDelivery: "Regional Delivery",
}

//RD and Yana are sharing these value. Do not change them unless get Yana confirmed.
export const enumPaymentOptions = {
    Cash: "Cash",
    Finance: "Finance",
}

//RD and Yana are sharing these value. Do not change them unless get Yana confirmed.
export const enumCountryCode = {
    Australia: "AU",
    NewZealand: "NZ",
}

export const enumCountryName = {
    Australia: "Australia",
    NewZealand: "New Zealand",
}

//RD and Yana are sharing the code value. Do not change the code unless get Yana confirmed.
export const enumClientTypes = {
    Private: {
        Code: "Private Customer",
        Text: "I'm a private customer",
    },
    Business: {
        Code: "Business Customer",
        Text: "I'm a business customer",
    },
};


export const enumMonth = [
    { name: 'JAN', code: '01' },
    { name: 'FEB', code: '02' },
    { name: 'MAR', code: '03' },
    { name: 'APR', code: '04' },
    { name: 'MAY', code: '05' },
    { name: 'JUE', code: '06' },
    { name: 'JUL', code: '07' },
    { name: 'AUG', code: '08' },
    { name: 'SEP', code: '09' },
    { name: 'OCT', code: '10' },
    { name: 'NOV', code: '11' },
    { name: 'DEC', code: '12' },
];

//RD and Yana are sharing these value. Do not change them unless get Yana confirmed.
export const enumVehicleOptionType = {
    Accessories: "Accessories",
    Charge: "Charge"
}


//These value are used to show label, and can be changed as scope request.
export const enumVehicleOptionTypeName = {
    Accessories: "Accessories",
    Charge: "Charging"
}

export const enumChargeType = {
    Public: 1,
    HomeWithoutPrice: 2,
    HomeHasPrice: 3
}

export const enumPage = {
    CheckoutPayment: 1,
    JoinWaitList: 2
}

export const enumInterestType = {
    Share: "Share",
    Save: "Save",
    Notify: "Notify",
    WaitingList: "Waitlist",
}

export const enumInterestSource = {
    ShopFront: "ShopFront",
    RequestCall: "RequestCall",
    RequestCallTestDrive: "RequestCallTestDrive"
}

export const enumRDErrorCode = {
    ExistedEmail: "RD0001",
    NotSignIn: "RD0002",
    MaxExtensionLimit: "RD0003",
    UnauthorisedAccess: "UnauthorisedAccess",
    OutOfStock: "ECM0010",
    NoActivity: "NoActivity",
}

export const enumRedirectPage = {
    CheckoutPaymentPage: "CheckoutPaymentPage"
}

export const enumOrderStatus = {
    Ordered: "Ordered",
    Confirmed: "Ordered Confirmed",
    Cancelled: "Cancelled",
    Delivered: "Delivered",
    PreparingToShip: "Preparing To Ship"
}

export const enumScrollSection = {
    Variant: "variant",
    Exterior: "exterior",
    Interior: "interior",
    Accessories: "accessories",
    Charging: "charging",
    Payment: "payment",
    Delivery: "delivery",
    Checkout: "checkout",
    CheckoutForm: "checkoutForm",
    Global: "global"
}

export const enumInstockPipelineStep = {
    OrderPlace: 1,
    ProvideDetail: 2,
    SignContract: 3,
    OrderConfirmed: 4,
    ScheduleDelivery: 5,
    ArrangePayment: 6,
    Delivered: 7
}

export const enumPipelineStep = {
    OrderPlace: 1,
    ProvideDetail: 2,
    SignContract: 3,
    OrderConfirmed: 4,
    VehicleInProduction: 5,
    PrepareToShip: 6,
    Shipped: 7,
    ScheduleDelivery: 8,
    ArrangePayment: 9,
    Delivered: 10
}

export const enumPipelineButtonID = {
    RetryPayment: 1,
    ProvideDetail: 2,
    StartYourApplication: 3,
    DownloadContract: 4,
    ReviewSignYourContract: 5,
    SchedulePickup: 6,
    ArranagePayment: 7,
    ViewAppointment: 8,
    ViewDelivery: 9
}

export const enumDocumentType = {
    DriveLicenseFront: "Drive License Front",
    DriveLicenseBack: "Drive License Back",
    Contract: "Contract",
    PaymentSummary: "PaymentSummary"
}

export const enumInventorySort: ICodeName[] = [
    { name: 'Lowest price', code: "0" },
    { name: 'Highest price', code: "1" },
];


export const enumTestDriveTransaction = {
    Book: "Book",
    Update: "Update",
    Cancel: "Cancel"
}


export const enumDeliveryPriceError = [
    {
        ErrorCode: "1",
        ErrorMessage: "We were unable to provide an accurate estimate for this delivery address. You can either try a different address or proceed with your order, and a member of our sales team will reach out to provide an estimate.",
    },
    {
        ErrorCode: "2",
        ErrorMessage: "We are unable to calculate your regional deliver cost estimate at this time.You can try again later or call our Cadillac Sales team on 1800***** for support through this step",  //todo: phone no
    }
];

export const enumErrorMessage = {
    AUReservationError: "Your reservation has expired. Please contact our Cadillac Sales Team on 1800 223455",
    NZReservationError: "Your reservation has expired. Please contact our Cadillac Sales Team on 0800 223455",
}

export const enumLinkSource = {
    RegularInterestLink: "Regular",
    PrivateInterestLink: "Private",
};

export const enumCallBackRequest = {
    CallBack: "Call Back",
    CancelOrder: "Cancel Order",
}

export const enumAuBank: bankInfoModel.IBankInfo = {
    BankName: "Bank of America, N.A.,",
    BankBranchName: "Sydney Branch",
    AccountName: "GENERAL MOTORS AUSTRALIA AND NEW ZEALAND PTY LTD",
    BSBNumber: "232-001",
    AccountNumber: "176 410 50",
    Phone: "1800 223 455"
}

export const enumPageLink = {
    AuthPage: "/auth",
    FromLink: "/links",
    TestDrivePage: "test-drive",
    ViewTestDrivePage: "view-test-drive",
    InventoryPage: "inventory",
    NewInventoryPage: "new-vehicle-inventory",
    OrderSuccessPage: "order-success",
    OrderWaitlistedPage: "order-waitlisted",
    MyOrderPage: "my-orders",
    ProfilePage: "profile",
    PrivacyPage: "privacy",
    SignInPage: "sign-in",
    Maintenance: "maintenance",
    RequestACall: "request-a-call",
}

export const enumNZBank: bankInfoModel.IBankInfo = {
    BankName: "CITIbank NA (New Zealand)",
    BankBranchName: "",
    AccountName: "General Motors New Zealand Ltd",
    BSBNumber: "31-2840",
    AccountNumber: "0044304-06",
    Phone: "0800 223 455"
}
const faq2Answer3 = `
    <p><sup>1</sup>This is the drive away price for the selected country, state or territory. It is based on the owner being a ‘rating one’ driver aged 40 with a good driving record. The drive away price displayed is inclusive of the vehicle purchase price, goods and services tax (GST), luxury car tax (LCT), stamp duty, compulsory third party insurance, registration, a plate fees and a GST-inclusive regional delivery fee if applicable. The final drive away price may differ depending on your individual circumstances. The price does not take into account any valid discount, rebate or promotion that may be available from time to time. Each country, state or territory may offer additional registration types which are not covered in this configurator, therefore your individual situation may vary and have an impact on the final Drive Away price. Cadillac reserves the right to vary the Drive away price at its discretion, including for changes in specifications or features. The final Drive Away price will be provided to you upon checkout.</p>
    <br/>
    <p><sup>2</sup>Comparison rate is based on a secured car loan of $30,000 repaid over 60 months, no balloon, and interest rate of 6.79%. Rates assume a customer with an excellent credit history. Rates shown are current as at today’s date. Terms, conditions, and credit criteria apply. Fees and charges apply. Interest rates are subject to change. <b>WARNING:</b> This comparison rate is true only for the examples given and may not include all fees and charges. Different terms, fees or other loan amounts might result in a different comparison rate.</p>
        <br/>
    <p>Terms, conditions and fees apply to any loan. Any calculations made by this calculator are dependent on the accuracy of the information provided, are intended to be used as a guide only, must not be relied on for any reason as conclusive, and do not constitute a quote or an offer of credit. Your application will be subject to a credit approval process and lending criteria. Cadillac will not store the information provided in this calculator. Cadillac and their finance partner do not accept any responsibility for any loss, costs, or liability directly or indirectly incurred by persons who rely on any amount calculated by this calculator.</p>
        <br/>
    <p>Credit subject to financier's approval. Terms, conditions, fees and charges apply. Rates, repayments and fees are estimates and are subject to change at any time. Credit provided by Plenti Finance Pty Limited ACN 636 759 861 (supported by its servicer, Plenti RE Limited ACN 166 646 635). Plenti RE Limited holds Australian Financial Services Licence number 449176 and Australian Credit Licence number 449176.</p>
        <br/>
    <p>This information does not constitute financial advice and you should consider whether it is appropriate to your circumstances before you act in reliance on it. For detailed advice and to discuss finance options tailored to your needs to determine the best finance option for your circumstances, we recommend speaking with a licensed independent financial advisor. Plenti's Target Market Determination is available at <a href="https://www.plenti.com.au/compliance/" target="_blank">https://www.plenti.com.au/compliance/</a>.</p>
`


export const enumTestDriveFAQs = [
    {
        id: "faq1",
        title: "What do I need to bring to my test drive?",
        context: "In Australia, we'll be required to sight a valid, full Australian Driver's License for all drivers. In New Zealand, we'll be required to sight a valid, full New Zealand Driver's License for all drivers. For all test drives, you'll be required to review and agree to Cadillac's Test Drive Terms & Conditions prior to your experience.",
        qa: []
    },
    {
        id: "faq2",
        title: "How do I reschedule or cancel my test drive?",
        context: "We understand things come up, so if you need to cancel or reschedule, please let us know as soon as possible by contacting your Cadillac Sales Ambassador, or by calling 1800 233 455 (Australia) or 0800 233 455 (New Zealand).",
        qa: []
    },
    {
        id: "faq3",
        title: "How long is the test drive?",
        context: "We allow 90 minutes for a test drive booking. We will typically start with a 15 minute walkthrough before driving, then take at least 30 minutes of driving time to show you what Cadillac electric vehicles have to offer.",
        qa: []
    },
    {
        id: "faq4",
        title: "Will the test drive be accompanied?",
        context: "Yes, one of our friendly Cadillac Sales Ambassadors will join you for the duration of your test drive.",
        qa: []
    },
    {
        id: "faq5",
        title: "Is there parking available at the test drive location?",
        context: "We want your test drive to be as seamless as possible - this includes parking. Upon booking your test drive, we will share details on how to access parking for that location.",
        qa: []
    }
]

export const constCurrentPromoName ="lyriq-eofy-discount-2025"